export default class TimeComplexity{ 
    constructor(best, average, worst){
        this.best = best;
        this.average = average;
        this.worst = worst;
    }
}